import { render, staticRenderFns } from "./ChannelsMenu.vue?vue&type=template&id=214180d6"
import script from "./ChannelsMenu.vue?vue&type=script&lang=js"
export * from "./ChannelsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports